import { z } from 'zod/v3';

// User action schema (transport-friendly, JSON-serializable)
export const ReplayUserActionSchema = z.object({
  type: z.enum(['click', 'input', 'select', 'scroll', 'navigation']),
  timestamp: z.number(),
  selector: z.string().optional(),
  value: z.string().optional(),
  text: z.string().optional(),
  href: z.string().optional(),
  x: z.number().optional(),
  y: z.number().optional(),
  url: z.string().optional()
});

export type ReplayUserAction = z.infer<typeof ReplayUserActionSchema>;

// Import generated enums to avoid conflicts
import { ReplaySessionModeSchema, ReplaySessionStatusSchema } from '../generated/enums';

// ReplaySession DTO
export const ReplaySessionDtoSchema = z.object({
  id: z.string(),
  flowId: z.string(),
  mode: ReplaySessionModeSchema,
  status: ReplaySessionStatusSchema,
  currentStepIndex: z.number(),
  startedAt: z.date(),
  completedAt: z.date().nullable(),
  userId: z.string(),
  organizationId: z.string(),
  workspaceId: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type ReplaySessionDto = z.infer<typeof ReplaySessionDtoSchema>;

// ReplaySessionResult DTO
export const ReplaySessionResultDtoSchema = z.object({
  id: z.string(),
  sessionId: z.string(),
  stepId: z.string(),
  analysis: z.any(), // JSON field - will contain ReplayStepAnalysis
  capturedScreenshot: z.string().nullable(),
  userAction: ReplayUserActionSchema.nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type ReplaySessionResultDto = z.infer<typeof ReplaySessionResultDtoSchema>;

// ReplaySession with Results DTO
export const ReplaySessionWithResultsDtoSchema = ReplaySessionDtoSchema.extend({
  results: z.array(ReplaySessionResultDtoSchema),
});

export type ReplaySessionWithResultsDto = z.infer<typeof ReplaySessionWithResultsDtoSchema>;

// Input DTOs for creating/updating
export const CreateReplaySessionInputSchema = z.object({
  flowId: z.string(),
  mode: ReplaySessionModeSchema,
  userId: z.string(),
  organizationId: z.string(),
  workspaceId: z.string(),
});

export type CreateReplaySessionInput = z.infer<typeof CreateReplaySessionInputSchema>;

export const CreateReplaySessionResultInputSchema = z.object({
  sessionId: z.string(),
  stepId: z.string(),
  analysis: z.any(),
  capturedScreenshot: z.string().optional(),
  userAction: ReplayUserActionSchema.optional(),
});

export type CreateReplaySessionResultInput = z.infer<typeof CreateReplaySessionResultInputSchema>;

// Type aliases for backward compatibility - re-export from generated enums
export type { ReplaySessionMode, ReplaySessionStatus } from '../generated/enums';